export class CompanyGroup {
    _id: string;
    name: string;

    constructor(companyGroup?) {
        if (companyGroup)
            this.populate(companyGroup)
    }

    private populate(companyGroup) {
        this._id = companyGroup._id;
        this.name = companyGroup.name;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/billing-letter/CompanyGroup.model.ts